import React from 'react'
import PeopleInvitedToOrg from 'src/app/PeopleInvitedToOrg/PeopleInvitedToOrg'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { peopleInvitedToOrgRouteProps } from 'src/navigation/routeProps'

const PeopleInvitedToOrgAppRoute: AppRoute = {
  id: AppLocation.PeopleInvitedToOrg,
  routeProps: peopleInvitedToOrgRouteProps,
  component: <PeopleInvitedToOrg />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default PeopleInvitedToOrgAppRoute
